import React from 'react'
import { useTranslation } from 'react-i18next'

import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'

interface ConfirmationDialogProps {
  header: string
  body: string | JSX.Element
  confirmButtonText: string
  type?: 'error' | 'primary'
  onConfirm: () => void
  onClose: () => void
}

const ConfirmationDialog = (props: ConfirmationDialogProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <Dialog open={true} onClose={props.onClose}>
      <DialogTitle>{props.header}</DialogTitle>
      <DialogContent>{props.body}</DialogContent>
      <DialogActions>
        <Button autoFocus onClick={props.onClose}>
          {t('common.cancel')}
        </Button>
        <Button variant="contained" color={props.type} onClick={props.onConfirm}>
          {props.confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmationDialog
